module.exports = __webpack_public_path__ + "static/media/OkkJiFast01.50f5a494.png";